(function($) {

  $(function() {

    $('.hide-if-empty').each(function() {
      if ( $.trim( $(this).text() ).length === 0 ) {
        $(this).hide();
      }
    });

    $('.event-online__countdown').each(function() {
      $(this).append("<div class='days'/>");
      $(this).append("<div class='hours'/>");
      $(this).append("<div class='minutes'/>");
      $(this).append("<div class='seconds'/>");

      var $this = $(this);
      var endDate = $this.attr('data-ends');
      var endTime = new Date(endDate);
      var nowTime = new Date();

      endTime = (Date.parse(endTime) / 1000);
      nowTime = (Date.parse(nowTime) / 1000);

      if ( nowTime > endTime ) {
        $this.parent().remove();
      }

      setInterval(function() { 
        nowTime = new Date();
        nowTime = (Date.parse(nowTime) / 1000);
    
        var timeLeft = endTime - nowTime;
    
        var days    = Math.floor(timeLeft / 86400); 
        var hours   = Math.floor((timeLeft - (days * 86400)) / 3600);
        var minutes = Math.floor((timeLeft - (days * 86400) - (hours * 3600 )) / 60);
        var seconds = Math.floor((timeLeft - (days * 86400) - (hours * 3600) - (minutes * 60)));
    
        if (hours < "10") { hours = "0" + hours; }
        if (minutes < "10") { minutes = "0" + minutes; }
        if (seconds < "10") { seconds = "0" + seconds; }
    
        $this.find(".days").html(days + "<span>Days</span>");
        $this.find(".hours").html(hours + "<span>Hrs</span>");
        $this.find(".minutes").html(minutes + "<span>Min</span>");
        $this.find(".seconds").html(seconds + "<span>Sec</span>");
      }, 1000);
    });

    $('a[href*="#"]').not('[class*="mfp-content"]').not('[href^="#tab"]').not('[href="#"]').not('[href="#0"]').click(function(event) {
      // On-page links
      if ( location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '') && location.hostname === this.hostname ) {
        // Figure out element to scroll to
        var target = $(this.hash);
        target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
        // Does a scroll target exist?
        if (target.length) {
          // Only prevent default if animation is actually gonna happen
          event.preventDefault();
          $('html, body').animate({
            scrollTop: target.offset().top - $('.elementor-sticky--active').offsetTop()
          }, 1000, function() {
            // Callback after animation
            // Must change focus!
            var $target = $(target);
            $target.focus();
            if ($target.is(":focus")) { // Checking if the target was focused
              return false;
            } else {
              $target.attr('tabindex','-1'); // Adding tabindex for elements not focusable
              $target.focus(); // Set focus again
            }
          });
        }
      }
    });

    $('.mfp-video').magnificPopup({
      type: 'iframe',
      closeOnBgClick: true
    });

    $('.mfp-content-link').magnificPopup({
      type: 'inline',
      closeOnBgClick: true,
      midClick: true
    });

    $('.elementor-tab-title').each(function() {
      var target = $(this).attr('aria-controls');
      if ( !$.trim( $('#'+target).html() ).length ) {
        $(this).hide();
      }
    });
    $('.elementor-toggle-item').each(function() {
      if ( !$.trim( $(this).find('.elementor-tab-content').html() ).length ) {
        $(this).hide();
      }
    });
    $('a.elementor-button').each(function() {
      if ( !$.trim( $(this).attr('href') ).length ) {
        $(this).hide();
      }
    });

    $('.elementor-widget-button[data-toggle="collapse"]').each(function() {
      var dataToggle       = $(this).attr('data-toggle');
      var dataTarget       = $(this).attr('data-target');
      var dataAriaExpanded = $(this).attr('aria-expanded');
      var dataAriaControls = $(this).attr('aria-controls');
      $(this).find('a').attr('data-toggle', dataToggle);
      $(this).find('a').attr('data-target', dataTarget);
      $(this).find('a').attr('aria-expanded', dataAriaExpanded);
      $(this).find('a').attr('aria-controls', dataAriaControls);
      $(this).attr('data-toggle', '');
      $(this).attr('data-target', '');
      $(this).attr('aria-expanded', '');
      $(this).attr('aria-controls', '');
    });

    $('.event-excerpt').on('click', function(e) {
      e.preventDefault();
      window.location = $(this).find('a').attr('href');
    });

    if ($(".woocommerce-product-gallery__image").length > 1)
    {
      $( ".woocommerce-product-gallery__image:not(:first-child)" ).addClass('swiper-slide').removeClass('woocommerce-product-gallery__image').wrapAll( '<div class="gallery-thumbs"><div class="swiper-wrapper">');
      $('<div class="swiper-button-prev"></div><div class="swiper-button-next"></div>').insertAfter('.swiper-wrapper');

      var swiper = new Swiper('.gallery-thumbs', {
        slidesPerView: 4,
        spaceBetween: 5,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        }
        });

    }
   });
    

    

})(jQuery);
